"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = allKeys;

var _isObject = _interopRequireDefault(require("./isObject.js"));

var _setup = require("./_setup.js");

var _collectNonEnumProps = _interopRequireDefault(require("./_collectNonEnumProps.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Retrieve all the enumerable property names of an object.
function allKeys(obj) {
  if (!(0, _isObject.default)(obj)) return [];
  var keys = [];

  for (var key in obj) {
    keys.push(key);
  } // Ahem, IE < 9.


  if (_setup.hasEnumBug) (0, _collectNonEnumProps.default)(obj, keys);
  return keys;
}